import React from "react";
import TaskListItem from "./TaskListItem";
import { formatDate } from "../../utils";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Importuj useTranslation

const TaskListMainItem = (props) => {
  const { item } = props || {};
  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  return (
    <div className="task-list-item">
      <Link to={`/task-detail/${item?.id}`}>
        <div className="task-list-item-header">
          <div className="task-list-item-header-title">{item?.name}</div>
          <div className="task-list-item-header-points">
            +{item?.experience} {t("taskListMainItem.taskExperienceLabel")}
          </div>
        </div>
        <div className="task-list-item-date">
          {t("taskListMainItem.taskEndDateLabel")}: {formatDate(item?.endDate)}{" "}
        </div>
      </Link>
    </div>
  );
};

export default TaskListMainItem;
